<template>
    <v-dialog v-model="dialog" :disabled="disabled" transition="dialog-center-transition" max-width="600">
        <template v-slot:activator="{props}">
            <v-tooltip location="bottom">
                <template v-slot:activator="{props: propsHover}">
                    <div v-bind="propsHover">
                        <v-btn
                            class="cursor-pointer"
                            variant="text"
                            icon="mdi-content-save-outline"
                            :color="'primary'"
                            v-bind="props"
                        />
                    </div>
                </template>
                <span> {{ $t('save_this_filter') }}</span>
            </v-tooltip>
        </template>
        <v-card>
            <v-card-title class="d-flex justify-space-between gc-2 text-wrap">
                {{ $t('save_filter') }}
                <v-spacer />
                <v-icon data-cy="close" size="x-small" class="mt-2 ml-auto" @click="close"> mdi-close </v-icon>
            </v-card-title>
            <v-card-text>
                {{ $t('save_the_current_settings_of_the_filter_as') }}
                <v-text-field
                    v-model="customFilterModel.text"
                    :label="$t('name')"
                    :rules="rules"
                    counter="25"
                    single-line
                    density="compact"
                />
                <v-radio-group v-model="customFilterModel.type" inline>
                    <v-radio :label="$t('just_for_me')" value="single" />
                    <v-radio :label="$t('for_all_users_of_my_company')" value="all" />
                </v-radio-group>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="close">
                    {{ $t('cancel') }}
                </v-btn>
                <v-btn
                    :loading="isLoading"
                    :disabled="isLoading || !customFilterModel.text"
                    variant="flat"
                    @click="save"
                >
                    {{ $t('save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import {clean, clone} from '@/utils/helpers'

    @Component
    export class CustomFilterModal extends Vue {
        @Prop() filters
        @Prop() person
        @Prop({type: Boolean}) disabled: boolean
        @Prop({default: 'custom_filters', type: String}) mongoCollection: string
        @Prop({required: false, type: Array}) companyType

        dialog = false
        isLoading: boolean = false
        customFilterModel = {
            text: '',
            type: 'single',
        }

        async save() {
            try {
                this.isLoading = true
                const customFilter = this.customFilterModel
                const creatorId = this.person.personId
                const companyId = this.person.companyId
                const filters = clone(this.filters)
                const id = `${creatorId}-${Date.parse(new Date())}`

                clean(filters)
                customFilter.filters = filters
                customFilter.creatorId = creatorId
                customFilter.companyId = companyId
                if (this.companyType) customFilter.companyType = this.companyType

                if (this.mongoCollection === 'custom_filters') await this.$api.customFilters.post({id, customFilter})
                if (this.mongoCollection === 'companies_custom_filters')
                    await this.$api.companiesCustomFilters.post({id, customFilter})

                this.$emit('create-custom-filter')
                this.close()
                // eslint-disable-next-line no-empty
            } catch (e) {
            } finally {
                this.isLoading = false
            }
        }

        close() {
            this.customFilterModel.text = ''
            this.customFilterModel.type = 'single'
            this.dialog = false
        }

        get rules() {
            return [v => v.length <= 25 || this.$t('validation.max_characters', {prop: 25})]
        }
    }

    export default CustomFilterModal
</script>
